(function () {
    var section = document.querySelector('[data-bz-learn-spice]');
    if (!section) return;
    var carousel = section.querySelector('.bz-spicecards');
    var nav = section.querySelector('[data-bz-spicecards-nav]');
    if (!carousel || !nav) return;
    var cards = carousel.querySelectorAll('.bz-spicecard');
    var dots = nav.querySelectorAll('[data-bz-spice-dot]');
    var prevBtn = nav.querySelector('[data-bz-spice-prev]');
    var nextBtn = nav.querySelector('[data-bz-spice-next]');
    if (!cards.length || !dots.length) return;

    var activeIndex = 0;

    function scrollToCard(i) {
      var card = cards[i];
      if (!card) return;
      // Center the target card inside the carousel viewport. Computing manually
      // (instead of card.scrollIntoView) so the page itself doesn't also jump
      // — scrollIntoView walks every scrolling ancestor.
      var carouselRect = carousel.getBoundingClientRect();
      var cardRect = card.getBoundingClientRect();
      var delta = (cardRect.left + cardRect.width / 2) - (carouselRect.left + carouselRect.width / 2);
      var targetLeft = carousel.scrollLeft + delta;
      try {
        carousel.scrollTo({ left: targetLeft, behavior: 'smooth' });
      } catch (e) {
        carousel.scrollLeft = targetLeft;
      }
    }

    function findCenteredIndex() {
      var carouselRect = carousel.getBoundingClientRect();
      var center = carouselRect.left + carouselRect.width / 2;
      var closest = 0;
      var closestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var r = cards[i].getBoundingClientRect();
        var d = Math.abs((r.left + r.width / 2) - center);
        if (d < closestDist) { closestDist = d; closest = i; }
      }
      return closest;
    }

    function setActive(i) {
      activeIndex = i;
      for (var j = 0; j < dots.length; j++) {
        if (j === i) dots[j].setAttribute('aria-current', 'true');
        else dots[j].removeAttribute('aria-current');
      }
      if (prevBtn) prevBtn.disabled = (i <= 0);
      if (nextBtn) nextBtn.disabled = (i >= cards.length - 1);
    }

    for (var i = 0; i < dots.length; i++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () { scrollToCard(idx); });
      })(i);
    }
    if (prevBtn) prevBtn.addEventListener('click', function () {
      if (activeIndex > 0) scrollToCard(activeIndex - 1);
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (activeIndex < cards.length - 1) scrollToCard(activeIndex + 1);
    });

    var scrollRaf = null;
    carousel.addEventListener('scroll', function () {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = null;
        setActive(findCenteredIndex());
      });
    }, { passive: true });

    setActive(findCenteredIndex());
  })();
